/* 清单数据库 页面 相关接口 */
import http from '@/assets/plugins/axios'
import {backendUrl} from '@/assets/js/config'
import queryString from 'querystring'
let headers = {'Content-type': 'application/x-www-form-urlencoded'}
export default {
  // 1. 获取所有的专业章节及地区等信息
  getMajorAndRegion (params) {
    return http.get(`${backendUrl}/data_manage/bill_quantity/catalogs`, params)
  },
  // 2. 获取所有的专业章节
  getMajorList (params) {
    return http.get(`${backendUrl}/data_manage/bill_quantity/professions`, params)
  },
  // 3. 获取编制人列表
  getAuthors (params) {
    return http.get(`${backendUrl}/data_manage/bill_quantity/authors`, params)
  },
  // 4. 根据专业章节获取地区
  getRegions (params) {
    return http.get(`${backendUrl}/data_manage/bill_quantity/regions`, params)
  },
  // 5. 清单列表 和 搜索
  getInventoryList (params) {
    return http.post(`${backendUrl}/data_manage/bill_quantity/list`, params, headers)
  },
  // 6. 修改清单
  edit (params) {
    return http.put(`${backendUrl}/data_manage/bill_quantity/item`, params, headers)
  },
  // 7. 审核清单
  inspect (params) {
    return http.put(`${backendUrl}/data_manage/bill_quantity/inspect`, params, headers)
  },
  // 7.1  批量审核清单
  inspectBatch (query, params) {
    return http.put(`${backendUrl}/data_manage/bill_quantity/inspect_batch?` + queryString.stringify(query), params, headers)
  },
  // 8. 删除清单
  delete (params) {
    return http.delete(`${backendUrl}/data_manage/bill_quantity`, params, headers)
  },
  // 9. 移动清单
  move (params) {
    return http.post(`${backendUrl}/data_manage/bill_quantity/move`, params, headers)
  },
  // 9.1 获取当前清单所属的 专业章节
  getInventoryChapter (params) {
    return http.get(`${backendUrl}/data_manage/bill_quantity/chapter`, params)
  },
  // 10. 导出清单
  export (params) {
    return http.post(`${backendUrl}/data_manage/bill_quantity/pre_export`, params, headers)
  },
  // 10.1 导出 下载文件
  download (fileName, token) {
    window.common.downloadFile(`${backendUrl}/data_manage/bill_quantity/export?fileName=${encodeURIComponent(fileName)}&token=${token}`)
  },
  // 11 上传云文件
  uploadCloudFile (params){
    return http.post(`${backendUrl}/data_manage/bill_quantity/upload_cloud_file`, params, headers)
  },
  // 11. 复制清单
  copy (params) {
    return http.post(`${backendUrl}/data_manage/bill_quantity/copy`, params, headers)
  }
}

